import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, List, Modal, message, notification } from "antd";
import { UserOutlined } from "@ant-design/icons";
import {
	FiCpu,
	FiRotateCcw,
	FiSmile,
	FiTrash2,
	FiUser,
	FiUserX,
} from "react-icons/fi";
import { MdOutlineLogout } from "react-icons/md";
import dayjs from "dayjs";
import { removeStorageWhenLogout, setHtmlStorage } from "../../config/helper";
import config from "../../config";
import * as actionProfile from "../../store/profile/action";
import * as actionSending from "../../store/sending/action";
import serviceAvatar from "../../services/avatar";
import serviceHome from "../../services/home";
import "./profile.css";
import ModalRemoveAccount from "./ModalRemoveAccount";
import ModalEditProfile from "./ModalEditProfile";
import ModalAvatarList from "./ModalAvatarList";
import { personalityMap } from "../../config/constant";
import ModalCustomizeAvatar from "./ModalCustomizeAvatar";
import ModalHistoryLog from "./ModalHistoryLog";
import ModalLastMessage from "./ModalLastMessage";
import ModalPromptLog from "./ModalPromptLog";
import ModalPrompt from "./ModalPrompt";
import ModalPromptUpdate from "./ModalPromptUpdate";

class Profile extends Component {
	constructor(props) {
		super(props);
		this.avatarCache = localStorage.getItem("dataAvatar");
		this.userRole = localStorage.getItem("userData");
		this.state = {
			popupShow: false,
			profileShow: false,
			avatarShow: false,
			avatarAddShow: false,
			removeAvatarShow: false,
			adminPromptShow: false,
			updatePromptShow: false,
			historyPromptShow: false,
			fullChatHistoryShow: false,
			lastMessageShow: false,
			typeAvatarForm: "create",
			id: null,
			name: null,
			pronouns: "He/Him",
			gender: "male",
			dobDay: "01",
			dobMonth: "Jan",
			dobYear: dayjs().subtract(18, "year").format("YYYY"),
			aiSrc: null,
			aiName: null,
			aiTraits: null,
			aiPersona: {
				first: 0,
				firstStr: [],
				second: 0,
				secondStr: [],
				third: 0,
				thirdStr: [],
			},
			activeAvatar: null,
			thePromptContext: null,
			thePromptCreatedDate: null,
			thePromptCreatedBy: null,
			theHistoryPrompt: [],
			theHistoryPromptItem: {},
		};
	}

	componentDidMount() {
		this.handleGetProfile();
		if (["mutazharara", "adhitlox", "sameh"].includes(this.userRole)) {
			this.handleGetPromptContext();
			this.handleGetHistoryPrompt();
		}
		if (!this.avatarCache) {
			this.setState({ avatarShow: true });
		} else {
			const { id } = JSON.parse(this.avatarCache);
			this.setState({ activeAvatar: id });
		}
	}

	componentDidUpdate(prevProps) {
		const { openSwitchAvatar } = this.props;
		const { openSwitchAvatar: prevOpenSwitchAvatar } = prevProps;

		if (openSwitchAvatar !== prevOpenSwitchAvatar) {
			const { avatarShow } = this.state;
			const newAvatarShow = this.avatarCache ? openSwitchAvatar : true;
			if (avatarShow !== newAvatarShow) {
				this.setState({ avatarShow: newAvatarShow });
			}
		}
	}

	handleGetProfile = async () => {
		await this.props.getProfile();

		if (this.props.profile.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, config.timeout);
		}
		if (this.props.profile.httpStatus === 404) {
			window.location.href = "/setting";
		}
		if (this.props.profile.httpStatus === 200) {
			this.setState({
				name: this.props.profile.data.name,
				pronouns: this.props.profile.data.pronouns,
				gender: this.props.profile.data.gender,
				dobDay: dayjs(this.props.profile.data.dob).format("DD"),
				dobMonth: dayjs(this.props.profile.data.dob).format("MMM"),
				dobYear: dayjs(this.props.profile.data.dob).format("YYYY"),
			});
		}
	};

	handleGetPromptContext = async () => {
		const response = await serviceHome.getPromptContext();

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, config.timeout);
		}
		if (response.httpStatus === 200) {
			this.setState({
				thePromptContext: response.data.promptText,
				thePromptCreatedDate: response.data.createdDate,
				thePromptCreatedBy: response.data.createdBy,
			});
		}
	};

	handleGetHistoryPrompt = async () => {
		const response = await serviceHome.getHistoryPrompt();

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, config.timeout);
		}
		if (response.httpStatus === 200) {
			this.setState({ theHistoryPrompt: response.data });
		}
	};

	handleGetDetailAvatar = async (id) => {
		const response = await serviceAvatar.getAvatar(id);

		if (response.httpStatus === 200) {
			const personalities = response.data.aIpersonality.split(" and ");
			const traits = response.data.aIinterests.split(", ");
			const personalityMap = {
				"Extremely Shy": "first",
				Shy: "first",
				Flirty: "first",
				"Extremely Flirty": "first",
				Friendly: "first",
				"Extremely Pessimistic": "second",
				Pessimistic: "second",
				Optimistic: "second",
				"Extremely Optimistic": "second",
				Rational: "second",
				"Extremely Open": "third",
				Open: "third",
				Mysterious: "third",
				"Extremely Mysterious": "third",
				Ordinary: "third",
			};

			const aiPersona = { ...this.state.aiPersona };
			personalities.forEach((person) => {
				if (personalityMap[person]) {
					aiPersona[personalityMap[person]] = person;
				}
			});
			this.setState({
				typeAvatarForm: "update",
				avatarAddShow: true,
				avatarShow: false,
				id: response.data.id,
				aiSrc: response.data.aIsrc,
				aiName: response.data.aIname,
				aiPersona,
				aiTraits: traits,
			});
		}

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, config.timeout);
		}

		if (response.httpStatus === 500) {
			notification.error({
				message:
					"Cannot get avatar detail, please try again in few minutes.",
			});
		}
	};

	handleSwapAvatar = async (id) => {
		const response = await serviceAvatar.swapAvatar(id);

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, config.timeout);
		}

		if (response.httpStatus === 200) {
			setHtmlStorage("dataAvatar", JSON.stringify(response.data));
			this.setState({
				activeAvatar: response.data.id,
			});
			setTimeout(() => {
				window.location.reload();
			}, config.timeout);
		}

		if (response.httpStatus === 500) {
			notification.error({
				message: "Something wrong, please try again in few minutes.",
			});
		}
	};

	handleDeleteChat = async (avatarID = this.state.activeAvatar) => {
		await this.props.deleteChatByID(avatarID);

		if (this.props.deleteChatResponse.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, config.timeout);
		}
		if (this.props.deleteChatResponse.httpStatus === 200) {
			notification.success({ message: "Chat has been clear." });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, config.timeout);
		}
		if (this.props.deleteChatResponse.httpStatus === 500) {
			message.error("Something wrong, please try again in few minutes.");
		}
	};

	handleLogout = () => {
		removeStorageWhenLogout();
		window.location.href = "/signin";
	};

	handleUpdateState = (value) => {
		this.setState({ ...this.state, ...value });
	};

	render() {
		return (
			<>
				<div className="profile-wrapper">
					<Button
						type="text"
						icon={<UserOutlined style={{ fontSize: 24 }} />}
						onClick={() => this.setState({ popupShow: true })}
					/>
				</div>

				{/* Main Menu */}
				<Modal
					footer={null}
					className="profile-modal"
					open={this.state.popupShow}
					onCancel={() => this.setState({ popupShow: false })}
					destroyOnClose
				>
					<div className="top-section">
						<div className="user-profile">
							<div className="user-profile-icon">
								<FiUser size={24} />
							</div>
							{this.state.name}
						</div>
						<List>
							<List.Item>
								<Button
									type="list-item"
									onClick={() => {
										this.setState({
											popupShow: false,
											profileShow: true,
										});
									}}
								>
									<FiUser size={24} />
									<span>Edit Your Profile</span>
								</Button>
							</List.Item>
							<List.Item>
								<Button
									type="list-item"
									onClick={() => {
										this.setState({
											popupShow: false,
											avatarShow: true,
										});
									}}
								>
									<FiSmile size={24} />
									<span>Edit AI Avatar Profile</span>
								</Button>
							</List.Item>
							<List.Item>
								<Button
									type="list-item"
									onClick={() => {
										this.setState({
											popupShow: false,
											removeAvatarShow: true,
										});
									}}
								>
									<FiUserX size={24} />
									<span>Remove My Account</span>
								</Button>
							</List.Item>
							<List.Item>
								<Button
									type="list-item"
									onClick={() => this.handleDeleteChat()}
								>
									<FiTrash2 size={24} />
									<span>Clear Conversation(s)</span>
								</Button>
							</List.Item>
							<List.Item>
								<Button
									type="list-item"
									onClick={() =>
										this.setState({
											fullChatHistoryShow: true,
											adminPromptShow: false,
										})
									}
								>
									<FiRotateCcw size={24} />
									<span>Chat History Log</span>
								</Button>
							</List.Item>
							{["mutazharara", "adhitlox", "sameh"].includes(
								this.userRole
							) && (
								<List.Item>
									<Button
										type="list-item"
										onClick={() =>
											this.setState({
												popupShow: false,
												adminPromptShow: true,
											})
										}
									>
										<FiCpu size={24} />
										<span>Admin Control Prompt</span>
									</Button>
								</List.Item>
							)}
						</List>
					</div>
					<div className="bottom-section">
						<Button type="primary" onClick={this.handleLogout}>
							Sign Out
							<MdOutlineLogout style={{ marginLeft: 5 }} />
						</Button>
					</div>
				</Modal>
				{/* Main Menu */}

				{/* Edit Profile */}
				<ModalEditProfile
					openModal={this.state.profileShow}
					onClose={this.handleUpdateState}
					profileData={{
						name: this.state.name,
						pronouns: this.state.pronouns,
						gender: this.state.gender,
						dobDay: this.state.dobDay,
						dobMonth: this.state.dobMonth,
						dobYear: this.state.dobYear,
					}}
				/>
				{/* Edit Profile */}

				{/* Avatar List */}
				<ModalAvatarList
					activeAvatar={this.state.activeAvatar}
					openModal={this.state.avatarShow}
					onClose={this.handleUpdateState}
					onAddAvatar={this.handleUpdateState}
					onEditAvatar={(value) => this.handleGetDetailAvatar(value)}
					onEmptyAvatar={this.handleUpdateState}
					onSwapAvatar={(value) => this.handleSwapAvatar(value)}
					profileResponse={this.props.profile}
				/>
				{/* Avatar List */}

				{/* Customize Avatar */}
				<ModalCustomizeAvatar
					avatarID={this.state.id}
					avatarDetail={{
						aiSrc: this.state.aiSrc,
						aiName: this.state.aiName,
						aiTraits: this.state.aiTraits,
						first: personalityMap[this.state.aiPersona["first"]],
						second: personalityMap[this.state.aiPersona["second"]],
						third: personalityMap[this.state.aiPersona["third"]],
					}}
					openModal={this.state.avatarAddShow}
					onClose={this.handleUpdateState}
					onDelete={this.handleDeleteChat}
					typeForm={this.state.typeAvatarForm}
				/>
				{/* Customize Avatar */}

				{/* Remove Account */}
				<ModalRemoveAccount
					openModal={this.state.removeAvatarShow}
					onClose={this.handleUpdateState}
				/>
				{/* Remove Account */}

				{/* History Log */}
				<ModalHistoryLog
					openModal={this.state.fullChatHistoryShow}
					onClose={this.handleUpdateState}
				/>
				{/* History Log */}

				{/* Last Message Log */}
				<ModalLastMessage
					openModal={this.state.lastMessageShow}
					onClose={this.handleUpdateState}
				/>
				{/* Last Message Log */}

				{/* Modal Prompt */}
				<ModalPrompt
					historyData={this.state.theHistoryPrompt}
					openModal={this.state.adminPromptShow}
					onClose={this.handleUpdateState}
					onClickItemPromptLog={this.handleUpdateState}
					onOpenLastMessageModal={this.handleUpdateState}
					onUpdatePrompt={this.handleUpdateState}
					promptData={{
						thePromptContext: this.state.thePromptContext,
						thePromptCreatedDate: this.state.thePromptCreatedDate,
						thePromptCreatedBy: this.state.thePromptCreatedBy,
					}}
				/>
				{/* Modal Prompt */}

				{/* Modal Prompt Update */}
				<ModalPromptUpdate
					openModal={this.state.updatePromptShow}
					onClose={this.handleUpdateState}
				/>
				{/* Modal Prompt Update */}

				{/* Prompt Log */}
				<ModalPromptLog
					contentItem={this.state.theHistoryPromptItem}
					openModal={this.state.historyPromptShow}
					onClose={this.handleUpdateState}
				/>
				{/* Prompt Log */}
			</>
		);
	}
}

const stateToProps = (state) => {
	const { profile, sending } = state;
	return {
		profile: profile.profile,
		deleteChatResponse: sending.deleteChatResponse,
	};
};

const dispatchToProps = (dispatch) => ({
	getProfile: () => dispatch(actionProfile.getProfile()),
	deleteChatByID: (avatarID) =>
		dispatch(actionSending.deleteChatByID(avatarID)),
});

export default connect(stateToProps, dispatchToProps)(Profile);
